import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { SalesSupportActionsService } from '../../../../../../services/sales-support-actions.service';
import { combineLatest } from 'rxjs';
import { AlertService } from '../../../../../../services/alert.service';
import { PATHS } from '../../../../../../models/bary-paths.model';
import dayjs from 'dayjs';
import { BaryModalService } from '../../../../../../services/bary-modal.service';
import { TransportView } from '../../../../../../models/transport-view.model';
import { CtaAction } from '../../../../../../models/cta.action';
import { TranslateService } from '@ngx-translate/core';
import { CurrentDataService } from '../../../../../../services/current-data-service';
import { LIST_ACTIONS } from '../../../../../../models/enums/action-cta.enum';
import { TypeSalesSupportActions } from '../../../../../../models/enums/types-sales-support-actions.enum';
import { ISalesSupportActions } from '../../../../../../models/sales-support-actions.model';

@Component({
  selector: 'jhi-transports-pending-list',
  templateUrl: './transports-pending-list.component.html',
})
export class TransportsPendingListComponent {
  @Input() public transportsPending: TransportView[] = [];
  @Input() public pagination!: Pagination;
  @Output() public paginationChange = new EventEmitter<Pagination>();

  public ctaActions: CtaAction[] = [];
  public readonly PATHS = PATHS;

  constructor(
    protected baryModalService: BaryModalService,
    protected translateService: TranslateService,
    protected jhiAlertService: AlertService,
    protected currentDataService: CurrentDataService,
    private salesSupportActionsService: SalesSupportActionsService
  ) {}



  public getCta(transportPendingView: TransportView): CtaAction[] {
    const ctaActions = [];
    ctaActions.push({
      icon: 'fa-eye',
      label: this.translateService.instant('unvalidatedBaskets.modal.actions.detail'),
      action: LIST_ACTIONS.DETAIL_TRANSPORT,
      disabled: false,
      dataIdCypress: 'detail-transport',
    });
    ctaActions.push({
      icon: 'fa-phone',
      label: this.translateService.instant('unvalidatedBaskets.modal.actions.contactCustomer'),
      action: LIST_ACTIONS.SHOW_POPIN_CONTACT,
      disabled: !transportPendingView.user,
      dataIdCypress: 'contact-customer',
    });
    ctaActions.push({
      icon: 'fa-lock',
      label: this.translateService.instant('unvalidatedBaskets.modal.actions.closeQuotation'),
      action: LIST_ACTIONS.CLOSE_TRANSPORT,
      disabled: false,
      dataIdCypress: 'close-transport',
    });

    return ctaActions;
  }

  public onSelectAction(cta: CtaAction, transportPendingView: TransportView): void {
    if (cta.action === LIST_ACTIONS.DETAIL_TRANSPORT) {
      if (transportPendingView.pickupDate) {
        transportPendingView.pickupDate = dayjs(transportPendingView.pickupDate);
      }
      if (transportPendingView.deliveryDate) {
        transportPendingView.deliveryDate = dayjs(transportPendingView.deliveryDate);
      }
      this.baryModalService
        .showDetailTransport(transportPendingView)
        .action()
        .subscribe({
          error: (err: any) => {
            console.error(err);
            this.jhiAlertService.addNotification({
              type: 'danger',
              message: this.translateService.instant('unvalidatedBaskets.error.contacter'),
            });
          },
        });
    }
    if (cta.action === LIST_ACTIONS.SHOW_POPIN_CONTACT) {
      this.baryModalService
        .showPopinContact(transportPendingView)
        .action()
        .subscribe({
          next: data => {
            if (data.submit) {
              this.jhiAlertService.addNotification({
                type: 'success',
                message: this.translateService.instant('unvalidatedBaskets.success.contacter'),
              });
              this.transition();
            }
          },
          error: (err: any) => {
            console.error(err);
            this.jhiAlertService.addNotification({
              type: 'danger',
              message: this.translateService.instant('unvalidatedBaskets.error.contacter'),
            });
          },
        });
    }
    if (cta.action === LIST_ACTIONS.CLOSE_TRANSPORT) {
      this.baryModalService
        .openConfirm(this.translateService.instant('unvalidatedBaskets.modal.body.message-clos-evt'))
        .action()
        .subscribe((action: any) => {
          if (action.submit) {
            this.closeTransport(transportPendingView);
          }
        });
    }
  }

  public closeTransport(transportPendingView: TransportView): void {
    combineLatest([this.currentDataService.getUser(), this.currentDataService.getCustomer()]).subscribe({
      next: (result): void => {
        const commercialFullName = `${result[0]?.firstName} ${result[0]?.lastName}`;
        const body = {
          typeSalesSupportActionsEnum: TypeSalesSupportActions.CLOSE,
          commercialId: result[1]?.id,
          transportId: transportPendingView.id,
          value: '{"date" : "' + dayjs().format('DD-MM-YYYY') + '" , "commercialId" : "' + result[1]?.id + '" , "commercialFullName" : "' + commercialFullName + '"}',
        } as ISalesSupportActions;
        this.salesSupportActionsService.post(body).subscribe({
          next: (): void => {
            this.jhiAlertService.addNotification({
              type: 'success',
              message: this.translateService.instant('unvalidatedBaskets.success.clos'),
            });
            this.transition();
          },
          error: (err: any): void => {
            console.error(err);
            this.jhiAlertService.addNotification({
              type: 'danger',
              message: this.translateService.instant('unvalidatedBaskets.error.clos'),
            });
          },
        });
      },
    });
  }

  public transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  public getObjectFromJson(json: any): { date: string; commercialId: string; commercialFullName: string } {
    return JSON.parse(json) as {
      date: string;
      commercialId: string;
      commercialFullName: string;
    };
  }

  public displayMoreEvent(salesSupportActionsList: ISalesSupportActions[]): void {
    const messages: string[] = salesSupportActionsList.map(
      val =>
        this.translateService.instant('unvalidatedBaskets.error.' + val.typeSalesSupportActionsEnum, {
          date: this.getObjectFromJson(val.value).date,
          commercialFullName: this.getObjectFromJson(val.value).commercialFullName,
        }) as string
    );
    this.baryModalService.showPopinEvtOnTransport(messages).action().subscribe();
  }

  public totalUM(transportPendingView: TransportView): number {
    return (transportPendingView.totalPallets ?? 0) + (transportPendingView.totalParcel ?? 0) + (transportPendingView.totalOtherUM ?? 0);
  }

  public getTotalUMTooltip(transportPendingView: TransportView): string {
    let result = '';
    if (transportPendingView.totalPallets) {
      result += transportPendingView.totalPallets + ' Palette(s)';
    }
    if (transportPendingView.totalParcel) {
      if (result.length > 0) {
        result += ', ';
      }
      result += transportPendingView.totalParcel + ' Colis';
    }
    if (transportPendingView.totalOtherUM) {
      if (result.length > 0) {
        result += ', ';
      }
      result += transportPendingView.totalOtherUM + ' UM(s)';
    }
    return result;
  }
}
